'use strict';

bbw.service.LocationSvc = Class({

    $inject: ['$compile', '$location', '$q', '$http', '$rootScope', '$timeout', 'setWindowTitle', 'bbw.RedirectSvc', 'inform', 'bbw.ServerTimeSvc', 'bbw.StatsSvc', 'rpcClient'],

    $compile: undefined,
    $location: undefined,
    $q: undefined,
    $rootScope: undefined,
    $timeout: undefined,
    $http: undefined,

    /**
     * @type {Function}
     */
    _setWindowTitle: null,

    /**
     * @type {bbw.service.RedirectSvc}
     */
    _redirectSvc: undefined,

    /**
     * @type {bbw.service.ServerTimeSvc}
     */
    _serverTimeSvc: undefined,

    /**
     * @type {bbw.service.StatsSvc}
     */
    _statsSvc: undefined,

    /**
     * @type {ngtk.rpcClient.Client}
     */
    _rpcClient: undefined,

    _inform: null,

    _statusTimeout: undefined,
    _element: undefined,
    _prevent: false,
    _scrollTopOnUriChange: true,

    _httpRequests: [],

    construct: function($compile, $location, $q, $http, $rootScope, $timeout, setWindowTitle, redirectSvc, inform, serverTimeSvc, statsSvc, rpcClient) {
        this.$compile = $compile;
        this.$location = $location;
        this.$q = $q;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this._redirectSvc = redirectSvc;
        this._setWindowTitle = setWindowTitle;
        this._inform = inform;
        this._serverTimeSvc = serverTimeSvc;
        this._statsSvc = statsSvc;
        this._rpcClient = rpcClient;
        this.$rootScope.$on('$destroy', this._setIsDestroying.bind(this));
        window.addEventListener('beforeunload', this._setIsDestroying.bind(this));
        this.$rootScope.locationStatus = {};
    },

    scrollTopOnUriChange: function(value) {
        this._scrollTopOnUriChange = !!value;
        return this;
    },

    createLocState: function(config) {
        if (!config.prevent) {
            config.prevent = function() {
                return this._prevent;
            }.bind(this);
        }
        return new bbw.service.LocState(this.$rootScope, this.$location, this.$q, this.$timeout, config);
    },

    setContainerElement: function(element) {
        if (angular.isDefined(this._element)) {
            throw new Error('Container element is already defined');
        }
        this._element = element;
        this._setup();
    },

    _getImportantPageUrlPart: function(url) {
        return new Uri(url).path();
    },

    _isDifferentPageUrl: function(newValue, oldValue) {
        return this._getImportantPageUrlPart(newValue) !== this._getImportantPageUrlPart(oldValue);
    },

    _getQueryImportantPart: function(value) {
        return new Uri(value).query().replace(/&?[\w\d_-]+=.*$/, '').replace(/^\?|\/$/, '');
    },

    _isUrlImportantPartChanged: function(newValue, oldValue) {
        if (this._isDifferentPageUrl(newValue, oldValue)) {
            return true;
        }
        return this._getQueryImportantPart(newValue) !== this._getQueryImportantPart(oldValue);
    },

    _setup: function() {
        this.$rootScope.$on('$locationChangeStart', function(event, newValue, oldValue) {
            if (!this._prevent && this._isDifferentPageUrl(newValue, oldValue)) {
                this.$rootScope.$broadcast('$locationChanging', {currentUrl: oldValue, newUrl: newValue});
                this._loadUrl(newValue);
            }
        }.bind(this));
        this.$rootScope.$on('$locationChangeSuccess', function(event, newValue, oldValue) {
            if (this._scrollTopOnUriChange && newValue !== oldValue && this._isUrlImportantPartChanged(newValue, oldValue)) {
                this._scrollTop();
            }
        }.bind(this));
    },

    cancelRunningRequests: function() {
        var prevRequestTimeout;
        while (prevRequestTimeout = this._httpRequests.shift()) {
            prevRequestTimeout.promise.$$ignore = true;
            prevRequestTimeout.resolve();
        }
    },

    _loadUrl: function(url) {
        this._rpcClient.cancelAll();
        this._redirectSvc && this._redirectSvc.cancel();
        this._setLocationStatus({loading: true, error: null});
        this.cancelRunningRequests();
        var deferred = this.$q.defer();
        this._httpRequests.push(deferred);
        this._inform.hideErrors(true);
        this._scrollTopOnUriChange = false;
        this.$rootScope.$broadcast(bbw.globalEvent.mobileBackHide);
        this.$http.get(bbw.pageUrl(url), {headers: {'X-Nav': true}, timeout: deferred.promise}).then(function(response) {
            var data = response.data;
            var status = response.status;
            var headers = response.headers;
            if (this._prevent || status < 0) {
                return;
            }
            var serverTime = headers('X-Server-Time');
            if (serverTime) {
                serverTime = parseInt(serverTime);
                if (!isNaN(serverTime)) {
                    this._serverTimeSvc.adjust(serverTime);
                }
            }
            var newRevision = headers('X-Rev');
            if (newRevision && bbw.updateRevision(newRevision) && !bbw.isDevelMode) {
                this._redirectSvc.redirect({url: url, xhr: false});
                return;
            }
            this._updateContents(data);
            data.uri && this._updateUri(data.uri);
            this._setLocationStatus({loading: false, error: null});
        }.bind(this)).catch(function(data) {
            var status = angular.isObject(data) ? data.status : 0;
            if (this._prevent || status < 0) {
                return;
            }
            if (status == 0 && data === null) {
                return;
            }
            if (angular.isObject(data) && data.xhrStatus == 'abort') {
                return;
            }
            var error;
            if (!status || status > 500) {
                error = 'connection_error';
            } else if (status == 404) {
                error = 'not_found';
            } else if (status == 403) {
                window.location = '/';
                return;
            } else {
                error = 'internal_error';
            }
            this._setLocationStatus({loading: false, error: error});
        }.bind(this)).finally(function() {
            this._scrollTop();
            this._scrollTopOnUriChange = true;
            var index = this._httpRequests.indexOf(deferred);
            if (~index) {
                this._httpRequests.splice(index, 1);
            }
            this._inform.hideErrors(false);
        }.bind(this));
    },

    getCurrentUri: function() {
        return this.$location.path();
    },

    _scrollTop: function() {
        window.scrollTo(0, 0);
    },

    _updateUri: function(dataUri) {
        var currentPath = this.$location.path(),
            responseUri = new Uri(dataUri),
            responsePath = responseUri.path(),
            responseSearch = responseUri.queryPairs.reduce(function(carry, pair) {
                return pair[0] === '_' || (carry[pair[0]] = pair[1]), carry;
            }, {});
        if (currentPath != responsePath) {
            this.$location.path(responsePath).search(responseSearch).replace();
        }
        this._statsSvc.hit(responsePath, responseSearch);
    },

    _normalizeBodyClass: function(value) {
        return ('' + value).trim().split(/\s+/).sort().join(' ');
    },

    _isBodyClassChanged: function(newContents) {
        var newBodyClass = this._normalizeBodyClass(newContents.body_class);
        var currentBodyClass = this._normalizeBodyClass(document.body.className);

        return newBodyClass !== currentBodyClass;
    },

    _updateContents: function(newContents) {
        if (newContents.$redirect || this._isBodyClassChanged(newContents)) {
            window.location = (newContents.uri || '/').replace(/[?&]_=[0-9]+/, '');
            return;
        }
        if (this._prevent) {
            return;
        }
        this._setWindowTitle(newContents.title, {}, true);
        var element = this._getElement();
        if (element.scope()) {
            element.scope().$destroy();
        }
        element.html(newContents.contents);
        this.$compile(element.contents())(this.$rootScope.$new());
    },

    _setLocationStatus: function(status) {
        if (this._statusTimeout) {
            this.$timeout.cancel(this._statusTimeout);
        }
        if (this._prevent) {
            return;
        }
        this._statusTimeout = this.$timeout(function() {
            angular.extend(this.$rootScope.locationStatus, status || {});
        }.bind(this));
    },

    _setIsDestroying: function() {
        this._prevent = true;
    },

    _getElement: function() {
        return angular.isFunction(this._element) ? this._element() : this._element;
    }

});

